import React, { memo, useEffect, useRef } from 'react'
import { Box } from '@mui/material'
import { m } from 'framer-motion'

import PageTitle from '../shared/pageTitle/PageTitle'
import { MainLayout } from '../../layouts/main'
import About from './About'
import MembershipLevels from './MembershipLevels'

const Welcome = ({ t, tiers }) => {
  const pageTitle = t('navigation.welcome')

  const membershipRef = useRef(null)

  const handleScrollToBenefits = () => {
    if (membershipRef.current) {
      membershipRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries
        if (entry.isIntersecting) {
          observer.disconnect()
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
      }
    )

    const currentRef = membershipRef.current

    if (currentRef) {
      try {
        observer.observe(currentRef)
      } catch (err) {
        console.error('IntersectionObserver error:', err)
      }
    }

    return () => {
      if (currentRef) observer.unobserve(currentRef)
      observer.disconnect()
    }
  }, [])

  return (
    <MainLayout>
      <PageTitle title={pageTitle} noHeading />
      <Box>
        <About t={t} onClickBenefits={handleScrollToBenefits} />
        <div ref={membershipRef} style={{ minHeight: '1px' }}>
          <m.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            <MembershipLevels t={t} tiers={tiers} />
          </m.div>
        </div>
      </Box>
    </MainLayout>
  )
}

export default memo(Welcome)
